export const resultCalculationFnc = (indicator: string | number) => {
  switch (indicator) {
    case 5:
    case 6:
      return plusCalculation;
    default:
      return divideCalculation;
  }
}

export const divideCalculation = (a?: string | number, b?: string | number): number => {
  // Nếu thiếu 1 trong 2 tham số
  if (!a || !b) return 0;

  const numerator = typeof a === "number" ? a : Number.parseFloat(a);
  const denominator = typeof b === "number" ? b : Number.parseFloat(b);

  // Nếu không phải số hoặc chia cho 0 thì trả về 0
  if (Number.isNaN(numerator) || Number.isNaN(denominator) || denominator === 0) {
    return 0;
  }

  return numerator / denominator;
}

export const multiplicationCalculation = (a?: string | number, b?: string | number): number => {
  // Nếu thiếu 1 trong 2 tham số
  if (!a || !b) return 0;

  const numerator = typeof a === "number" ? a : Number.parseFloat(a);
  const denominator = typeof b === "number" ? b : Number.parseFloat(b);

  // Nếu không phải số hoặc chia cho 0 thì trả về 0
  if (Number.isNaN(numerator) || Number.isNaN(denominator) || denominator === 0) {
    return 0;
  }

  return numerator * denominator;
}

export const plusCalculation = (arr: (string | number)[]): number => {
  return arr.reduce((total: number, value) => {
    const num = typeof value === "number" ? value : Number.parseFloat(value);
    return total + (Number.isNaN(num) ? 0 : num);
  }, 0);
}
